export default __webpack_public_path__ + "6fea17674545f26cb2fc5a43011e3a5a.jpg";